module.exports = __webpack_public_path__ + "img/bx-manage-activity-active.78ec6c76.svg";